
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/schools",
      function () {
        return require("private-next-pages/partners/schools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/schools"])
      });
    }
  